import React from 'react';
import styles from './index.scss';
import { LearningInfo } from '@/api/seller/serv/oec_seller_learning_center_api';
import cx from 'classnames';
import { useModuleCard } from '@/containers/module-landing/module-card/index.ViewHook';

export enum ModuleCardType {
  HotModule = 1,
  ExploreModule = 2,
}

interface ModuleCardProps {
  info?: LearningInfo;
  type: ModuleCardType;
}

export const ModuleCard: React.FC<ModuleCardProps> = props => {
  const { info } = props;
  const { imgSrc, style, jumpToCourse } = useModuleCard(props.type, info);

  return (
    <section
      className={cx(styles.container, style)}
      onClick={() => jumpToCourse(info?.learning_id)}>
      <div
        className={styles.img}
        style={{ backgroundImage: `url(${imgSrc})` }}
      />
      <div className={styles.box}>
        <p className={styles.title}>{info?.name}</p>
        <p className={styles.desc}>{info?.description}</p>
      </div>
    </section>
  );
};
